import { render } from "./Employees.vue?vue&type=template&id=03417161"
import script from "./Employees.vue?vue&type=script&lang=ts"
export * from "./Employees.vue?vue&type=script&lang=ts"
script.render = render

export default script